const BADGE_BASE = 'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold tracking-wide';

export const LEAD_STATUS_LABEL = {
  NEW: 'NOUVEAU',
  CONTACTED: 'CONTACTÉ',
  QUALIFIED: 'QUALIFIÉ',
  WON: 'GAGNÉ',
  LOST: 'PERDU',
};

export const LEAD_STATUS_CLASS = {
  NEW: `${BADGE_BASE} bg-primary-50 text-primary-800`,
  CONTACTED: `${BADGE_BASE} bg-slate-100 text-slate-700`,
  QUALIFIED: `${BADGE_BASE} bg-amber-50 text-amber-800`,
  WON: `${BADGE_BASE} bg-emerald-50 text-emerald-800`,
  LOST: `${BADGE_BASE} bg-rose-50 text-rose-800`,
};

export function footerLinkBadge({ published, enabled }) {
  if (published && enabled !== false) {
    return { label: 'En ligne', className: `${BADGE_BASE} bg-emerald-50 text-emerald-800` };
  }
  if (!published && enabled !== false) {
    return { label: 'À publier', className: `${BADGE_BASE} bg-amber-50 text-amber-800` };
  }
  if (published && enabled === false) {
    return { label: 'Masqué', className: `${BADGE_BASE} bg-gray-100 text-gray-600` };
  }
  return { label: 'Non publié', className: `${BADGE_BASE} bg-gray-100 text-gray-600` };
}

export function pageStatusBadge(page) {
  if (!page?.publishedRevisionId) {
    return { label: 'Non publié', className: `${BADGE_BASE} bg-gray-100 text-gray-600` };
  }
  if (page.hasUnpublishedChanges || page.status === 'DRAFT_CHANGED') {
    return { label: 'Brouillon à publier', className: `${BADGE_BASE} bg-amber-50 text-amber-800` };
  }
  return { label: 'En ligne', className: `${BADGE_BASE} bg-emerald-50 text-emerald-800` };
}

export function professionalsPageLiveBadge(published) {
  if (published) {
    return { label: 'En ligne', className: `${BADGE_BASE} bg-emerald-50 text-emerald-800` };
  }
  return { label: 'Non publiée', className: `${BADGE_BASE} bg-gray-100 text-gray-600` };
}

export async function copyProfessionalsPublicUrl(url, clipboard) {
  if (!url || !clipboard?.writeText) {
    throw new Error('CLIPBOARD_UNAVAILABLE');
  }
  await clipboard.writeText(url);
  return url;
}

export function proBlockBadge({ proBlockEnabled, professionalPublished }) {
  if (proBlockEnabled === false) {
    return { label: 'Bloc masqué', className: `${BADGE_BASE} bg-gray-100 text-gray-600` };
  }
  if (!professionalPublished) {
    return {
      label: 'Publiez d’abord la page Professionnels',
      className: `${BADGE_BASE} bg-amber-50 text-amber-800`,
    };
  }
  return { label: 'Bloc visible sur le site', className: `${BADGE_BASE} bg-emerald-50 text-emerald-800` };
}

export function leadStatusBadge(status) {
  const code = LEAD_STATUS_LABEL[status] ? status : 'NEW';
  return {
    label: LEAD_STATUS_LABEL[code],
    className: LEAD_STATUS_CLASS[code],
  };
}

export function formatFollowUp(value) {
  if (!value) return '';
  try {
    return new Date(value).toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '';
  }
}
